import { render, staticRenderFns } from "./basic-data-visualizer.vue?vue&type=template&id=86aad9ae&scoped=true&"
import script from "./basic-data-visualizer.vue?vue&type=script&lang=js&"
export * from "./basic-data-visualizer.vue?vue&type=script&lang=js&"
import style0 from "./basic-data-visualizer.vue?vue&type=style&index=0&id=86aad9ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86aad9ae",
  null
  
)

export default component.exports